import AuthService from '../../services/AuthService';

export default {
  error: {},
  info: {},
  success: {},
  stepsCompleted: [],
  skippedSteps: [],
  preferredLanguages: [
    { key: 'English', value: 'en' },
    { key: 'हिन्दी', value: 'hi' },
    { key: 'ಕನ್ನಡ', value: 'kn' },
  ],
  selectedLanguage: {},
  userName: AuthService.getUserName(),
  gender: '',
  userMobile: AuthService.getUserMobile(),
  isValidNumber: false,
  userOTP: '',
  isValidOTP: false,
  isAPIProgress: false,
  userAge: '',
  userWorkCity: {},
  isFetchLocation: false,
  qualification: '',
  jobDuration: '',
  jobCategories: [],
  userProfile: {},
  jobLocalities: [],
  userWorkExp: [],
  userSkills: [],
  userJobPref: {},
  currentEditItem: '',
  currentWarningItem: '',
  pendingDocs: {},
  jobCategoriesItems: [],
  requirements: {},
  selectedSalary: 0,
  isLoginOptionVisible: false,
  isFacebookLoginInProgress: false,
  mobile: '',
  otp: '',
  expectedSalaries: [
    { key: 'Above ₹5,000', value: 5000 },
    { key: 'Above ₹10,000', value: 10000 },
    { key: 'Above ₹20,000', value: 20000 },
    { key: 'Above ₹30,000', value: 30000 },
    { key: 'Above ₹40,000', value: 40000 },
  ],
};
